import { render, staticRenderFns } from "./CbsObjectsImport.vue?vue&type=template&id=1d5f0eb6&scoped=true"
import script from "./CbsObjectsImport.vue?vue&type=script&lang=js"
export * from "./CbsObjectsImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f0eb6",
  null
  
)

export default component.exports